import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { Enums } from '../../shared/models/enums';
import { CellRendererElementSubTypes } from '../../shared/widgets/data-grid/enums/cell-renderer-element-Subtype.enum';
import { CellRendererElementTypes } from '../../shared/widgets/data-grid/enums/cell-renderer-element.enum';
import { CellRendererTypes } from '../../shared/widgets/data-grid/enums/cell-renderer.enum';
import { FilterTypes } from '../../shared/widgets/data-grid/enums/filter-types.enum';
import { TableColumn } from '../../shared/widgets/data-grid/interfaces/table-column.interface';

@Injectable()
export class MyProjectGridService {

    cols: Array<TableColumn> = [
        {
            field: '',
            header: 'Checkbox',
            columnCheckBox: true,
            pinned: true,
            sort: false,
            style: { 'width': '50px', 'min-width': '50px', 'max-width': '50px' }
        },
        {
            field: 'subprojectName',
            header: 'Subproject Name',
            pinned: true,
            sort: true,
            sortName: 'subprojectName',
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onSubprojectNameclick'
            }
        },
        {
            field: 'projectNumber',
            header: 'Project Number',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'fileNumber',
            header: 'File Number',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'emailId',
            header: 'Email Id',
            sort: true,
            sortName: 'emailID',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.emailIdCellRenderer
            }
        },
        {
            field: 'title',
            header: 'Title'
        },
        {
            field: 'firstName',
            header: 'First Name',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'lastName',
            header: 'Last Name',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'projectName',
            header: 'Project Name',
            sort: true,
            sortName: 'projectName',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'masterArea',
            header: 'Project Floor Area(m²)'
        },
        {
            field: 'versionNumber',
            header: 'Version Number',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'shareProjLinkEnabled',
            header: 'Share Subproject',
            displayName: 'Share',
            isEnable: 'shareProjLinkEnabled',
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onShareSubprojectclick',
                elementsubType: CellRendererElementSubTypes.share,
            }
        },
        {
            field: 'intentToCertify',
            header: 'Intent to Certify',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Not Sure', value: 'Not Sure' },
                    { label: 'Yes', value: 'Yes' },
                    { label: 'No', value: 'No' }
                ]
            },
        },
       
        {
            field: 'shareWithInvestor',
            header: 'Share with Bank(s)',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Not Available', value: 'NA' },
                    { label: 'Yes', value: '1' },
                    { label: 'No', value: '0' }
                ]
            },
        },
        {
            field: 'projectTrainingPurpose',
            header: 'Training Purpose',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Yes', value: '1' },
                    { label: 'No', value: '0' }
                ]
            },
        },
      
        {
            field: 'subprojectType',
            header: 'Subproject Type'
        },
        {
            field: 'buildingType',
            header: 'Building Type',
            sort: true,
            sortName: 'buildingType'
        },
        {
            field: 'noOfUnits',
            header: 'Units'
        },
        {
            field: 'country',
            header: 'Country',
            sort: true,
            sortName: 'country'
        },
        {
            field: 'city',
            header: 'City',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'certificationStage',
            header: 'Certification Stage',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Preliminary', value: 'Preliminary' },
                    { label: 'Post-Construction', value: 'Post-Construction' }
                ]
            },
        },
        {
            field: 'certificationStatus',
            header: 'Certification Status',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Self-Review', value: 'Self-Review' },
                    { label: 'Select Certifier', value: 'Select Certifier' },
                    { label: 'Project Registered', value: 'Project Registered' },
                    { label: 'Auditor Selection', value: 'Select Auditor' },
                    { label: 'Project Under Audit', value: 'Project Under Audit' },
                    { label: 'Auditor Feedback', value: 'Auditor Feedback' },
                    { label: 'Project Under Review', value: 'Project Under Review' },
                    { label: 'Project Under Certifier Review', value: 'Project Under CA Review' },
                    { label: 'Certifier Feedback', value: 'Certifier Feedback' },
                    { label: 'Certified', value: 'Certified' },
                    { label: 'Certificate Issued', value: 'Certificate Issued' }
                ]
            },
        },
        {
            field: 'createdDate',
            header: 'Created Date',
            sort: true,
            sortName: 'createdDate',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'lastActivity',
            header: 'Last Activity',
            sort: true,
            sortName: 'lastActivity',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'energySavings',
            header: 'Energy',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.savingsCellRenderer
            }
        },
        {
            field: 'waterSavings',
            header: 'Water',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.savingsCellRenderer
            }
        },
        {
            field: 'materialSavings',
            header: 'Material',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.savingsCellRenderer
            }
        },
        {
            field: 'energySavingsPerYear',
            header: 'Energy Savings(MWh/Year)',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'waterSavingsPerYear',
            header: 'Water Savings(m³/Year)',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        ,
        {
            field: 'embodiedEnergyMaterialSavings',
            header: 'Embodied Energy in Materials Savings(GJ)',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'embodiedCarbonMaterialSavings',
            header: 'Embodied Carbon in Materials Savings(tCO₂e)',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'cO2SavingsPerYear',
            header: 'CO₂ Savings(tCO₂/Year)',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'floorSpaceCertified',
            header: 'Subproject Floor Area(m²)',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'documentsUploaded',
            header: 'Documents Uploaded',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Yes', value: 'true' },
                    { label: 'No', value: 'false' },
                ]
            },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.documentsUploadedCellRenderer
            }
        },
        {
            field: 'dateSubmittedForRegistration',
            header: 'Date Submitted for Registration',
            sort: true,
            sortName: 'dateSubmittedForRegistration',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'projectAddress',
            header: 'Address'
        },
        {
            field: 'isDeleteEnabled',
            header: 'Delete Subproject',
            displayName: ' ',
            isEnable: 'isDeleteEnabled',
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onDeleteSubprojectclick',
                elementsubType: CellRendererElementSubTypes.delete,
            }
        },
    ];

    colsForCountryAdmin: Array<TableColumn> = [
        {
            field: 'subprojectName',
            header: 'Subproject Name',
            sort: true,
            sortName: 'subprojectName',
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onSubprojectNameclick'
            },
            pinned: true
        },
        {
            field: 'projectNumber',
            header: 'Project Number',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'fileNumber',
            header: 'File Number',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'emailId',
            header: 'Email Id',
            sort: true,
            sortName: 'emailID',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.emailIdCellRenderer
            }
        },
        {
            field: 'title',
            header: 'Title'
        },
        {
            field: 'firstName',
            header: 'First Name',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'lastName',
            header: 'Last Name',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'projectName',
            header: 'Project Name',
            sort: true,
            sortName: 'projectName',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'masterArea',
            header: 'Project Floor Area(m²)'
        },
        {
            field: 'versionNumber',
            header: 'Version Number',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'shareProjLinkEnabled',
            header: 'Share Subproject',
            displayName: 'Share',
            isEnable: 'shareProjLinkEnabled',
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onShareSubprojectclick',
                elementsubType: CellRendererElementSubTypes.share,
            }
        },
        {
            field: 'intentToCertify',
            header: 'Intent to Certify',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Not Sure', value: 'Not Sure' },
                    { label: 'Yes', value: 'Yes' },
                    { label: 'No', value: 'No' }
                ]
            },
        },
       
        {
            field: 'shareWithInvestor',
            header: 'Share with Bank(s)',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Not Available', value: 'NA' },
                    { label: 'Yes', value: '1' },
                    { label: 'No', value: '0' }
                ]
            },
        },
        {
            field: 'projectTrainingPurpose',
            header: 'Training Purpose',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Yes', value: '1' },
                    { label: 'No', value: '0' }
                ]
            },
        },
     
        {
            field: 'subprojectType',
            header: 'Subproject Type'
        },
        {
            field: 'buildingType',
            header: 'Building Type',
            sort: true,
            sortName: 'buildingType'
        },
        {
            field: 'noOfUnits',
            header: 'Units'
        },
        {
            field: 'country',
            header: 'Country',
            sort: true,
            sortName: 'country'
        },
        {
            field: 'city',
            header: 'City',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'certificationStage',
            header: 'Certification Stage',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Preliminary', value: 'Preliminary' },
                    { label: 'Post-Construction', value: 'Post-Construction' }
                ]
            },
        },
        {
            field: 'certificationStatus',
            header: 'Certification Status',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Self-Review', value: 'Self-Review' },
                    { label: 'Select Certifier', value: 'Select Certifier' },
                    { label: 'Project Registered', value: 'Project Registered' },
                    { label: 'Auditor Selection', value: 'Select Auditor' },
                    { label: 'Project Under Audit', value: 'Project Under Audit' },
                    { label: 'Auditor Feedback', value: 'Auditor Feedback' },
                    { label: 'Project Under Review', value: 'Project Under Review' },
                    { label: 'Project Under Certifier Review', value: 'Project Under CA Review' },
                    { label: 'Certifier Feedback', value: 'Certifier Feedback' },
                    { label: 'Certified', value: 'Certified' },
                    { label: 'Certificate Issued', value: 'Certificate Issued' }
                ]
            },
        },
        {
            field: 'createdDate',
            header: 'Created Date',
            sort: true,
            sortName: 'createdDate',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'lastActivity',
            header: 'Last Activity',
            sort: true,
            sortName: 'lastActivity',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'energySavings',
            header: 'Energy',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.savingsCellRenderer
            }
        },
        {
            field: 'waterSavings',
            header: 'Water',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.savingsCellRenderer
            }
        },
        {
            field: 'materialSavings',
            header: 'Material',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.savingsCellRenderer
            }
        },
        {
            field: 'energySavingsPerYear',
            header: 'Energy Savings(MWh/Year)',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'waterSavingsPerYear',
            header: 'Water Savings(m³/Year)',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'embodiedEnergyMaterialSavings',
            header: 'Embodied Energy in Materials Savings(GJ)',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'embodiedCarbonMaterialSavings',
            header: 'Embodied Carbon in Materials Savings(tCO₂e)',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'cO2SavingsPerYear',
            header: 'CO₂ Savings(tCO₂/Year)',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'floorSpaceCertified',
            header: 'Subproject Floor Area(m²)',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'documentsUploaded',
            header: 'Documents Uploaded',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Yes', value: 'true' },
                    { label: 'No', value: 'false' },
                ]
            },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.documentsUploadedCellRenderer
            }
        },
        {
            field: 'dateSubmittedForRegistration',
            header: 'Date Submitted for Registration',
            sort: true,
            sortName: 'dateSubmittedForRegistration',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'projectAddress',
            header: 'Address'
        },
        {
            field: 'isDeleteEnabled',
            header: 'Delete Subproject',
            displayName: ' ',
            isEnable: 'isDeleteEnabled',
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onDeleteSubprojectclick',
                elementsubType: CellRendererElementSubTypes.delete,
            }
        },
    ];

    modalRef: MDBModalRef;
    confirmationStatus = Enums.confirmationStatus;
    private callbackProjDOcUploadModalClose = new Subject<any>(); // Source
    eventCallbackProjDocuUploadModalClose$ = this.callbackProjDOcUploadModalClose.asObservable(); // Stream
    constructor() { }

    emailIdCellRenderer(rowData, field) {
        if (rowData[field]) {
            return '<a href="mailto:' + rowData[field] + '">' + rowData[field] + '</a>';
        } else {
            return '';
        }
    }

    dateCellRenderer(rowData, field) {
        if (rowData[field]) {
            const value = formatDate(rowData[field], 'yyyy-MM-dd hh:mm a', 'en-US');
            return `<div class="text-truncate" title="` + value + `">` + value + `</div>`;
        } else {
            return '';
        }
    }

    savingsCellRenderer(rowData, field) {
        if (rowData[field]) {
            const percent = parseFloat(rowData[field].replace('%', ''));
            if (!Number.isNaN(percent) && percent >= 20) {
                return `<div class="text-green text-truncate" title="` + rowData[field] + `">` + rowData[field] + `</div>`;
            } else {
                return rowData[field];
            }
        } else {
            return '';
        }
    };

    documentsUploadedCellRenderer(rowData, field) {
        return rowData[field] ? 'Yes' : 'No';
    }

    fixedTo2Decimal(rowData, field) {
        if (rowData[field]) {
            const value = parseFloat(rowData[field]);
            return !Number.isNaN(value) ? `<div class="text-truncate" title="` + value.toFixed(2) + `">` + value.toFixed(2) + `</div>` : rowData[field];
        } else {
            return '0.00';
        }
    }


}
